import React from 'react';

import Icon from '../../assets/icons';

import { HeaderContainer, HeaderContent, HeaderTitle } from './styles';

const Header = () => (
  <HeaderContainer>
    <HeaderContent>
      <Icon variant="logo" />
      <HeaderTitle>Universal School of Negotiation</HeaderTitle>
    </HeaderContent>
  </HeaderContainer>
);

export default Header;
